import { useImmerAtom } from 'jotai-immer';
import { tableFiltersAtom, tableStateAtom, tableStatsAtom, tableViewAtom } from '../vendor_list_atoms';
import { ListTableStateHookReturn, TblPagination, TblSortDir } from '../../../../core/table/table.types';
import { tblSpecSetFilter, tblSpecSetSort } from '../../../../core/table/spec';
import { useCallback } from 'react';

export const useVendorListTableState = (): ListTableStateHookReturn => {
    const [state, setState] = useImmerAtom(tableStateAtom);
    const [view, setView] = useImmerAtom(tableViewAtom);
    const [filters, setFilters] = useImmerAtom(tableFiltersAtom);
    const [stats, setStats] = useImmerAtom(tableStatsAtom);

    const setPaging = useCallback(
        (paging: Partial<TblPagination>): void => {
            setStats(draft => {
                if (paging.page !== undefined) {
                    draft.paging.page = paging.page;
                }
                if (paging.size !== undefined) {
                    draft.paging.size = paging.size;
                }
                if (paging.total !== undefined) {
                    draft.paging.total = paging.total;
                }
            });
        },
        [setStats],
    );

    const setSort = useCallback(
        (col: string, dir?: TblSortDir): void => {
            setView(draft => {
                draft.sort = tblSpecSetSort(col, view.cols, dir);
            });
        },
        [setView, view.cols],
    );

    const setFilter = useCallback(
        (key: string, val: any): void => {
            setFilters(draft => tblSpecSetFilter(draft, key, view.cols, val));
        },
        [setFilters, view.cols],
    );

    const setWait = useCallback(
        (waiting: boolean): void => {
            setState(draft => {
                draft.waiting = waiting;
            });
        },
        [setState],
    );

    return {
        waiting: state.waiting,
        views: state.views,
        currentViewId: state.currentViewId,
        cols: view.cols,
        sections: view.sections,
        sort: view.sort,
        filters: filters,
        fltStats: stats.fltStats,
        paging: stats.paging,
        setWait,
        setSort,
        setFilter,
        setPaging,
    };
};
